import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { OptimizedDataDto } from "@reactive-resume/dto";

type GetOptimizationResultsParams = {
  id: string;
};

export const getOptimizationResults = async ({ id }: GetOptimizationResultsParams) => {
  const response = await axios.get<{
    [props: string]: any;
    data: OptimizedDataDto;
  }>(`/resume-optimizer/optimization/${id}`);
  return response.data;
};

export const useGetOptimizationResults = (
  params: GetOptimizationResultsParams,
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: ["resume-optimizer", "optimization", params.id],
    queryFn: () => getOptimizationResults(params),
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    ...options,
  });
};
